var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4042 3.94384L20 2.41717V2.08301H14.4717L10.5317 11.8897L6.04917 2.08301H0.2525V2.41717L2.11667 4.66134C2.29833 4.82717 2.39333 5.06967 2.36917 5.31384V14.133C2.42667 14.4505 2.32333 14.7772 2.1 15.008L0 17.553V17.883H5.95417V17.5488L3.85417 15.008C3.62667 14.7763 3.51917 14.4555 3.565 14.133V6.50467L8.79167 17.8872H9.39917L13.8933 6.50467V15.5722C13.8933 15.8113 13.8933 15.8605 13.7367 16.0172L12.12 17.5813V17.9163H19.9633V17.5822L18.405 16.0563C18.2683 15.953 18.1975 15.7797 18.2267 15.6113V4.38884C18.1975 4.21967 18.2675 4.04634 18.4042 3.94384Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.16c1dfbd4c2c47ddfb10e009e3ade139.svg";
export { ForwardRef as ReactComponent };